const STATS = [
  { value: "120+", label: "Films delivered" },
  { value: "40+", label: "Nonprofits served" },
  { value: "6yr", label: "In production" },
  { value: "$28M", label: "Raised by client galas" },
];

const ABOUT_IMG =
  "https://customer-assets.emergentagent.com/job_cinematic-minimal-1/artifacts/sw1bj5e0_PHOTO-2024-11-25-20-46-25.jpg";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-36 px-6 md:px-12 lg:px-16 border-t border-[#1a1a1a]"
    >
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
        {/* Image column */}
        <div className="lg:col-span-5 reveal">
          <div className="relative overflow-hidden aspect-[4/5] bg-black">
            <img
              src={ABOUT_IMG}
              alt="Behind the scenes — Insight Media Productions"
              className="h-full w-full object-cover"
            />
            <div className="absolute bottom-5 left-5 right-5 flex items-end justify-between">
              <div>
                <p className="eyebrow text-white/70">Founder</p>
                <p className="font-display-md text-lg md:text-xl mt-1">
                  Benny Dukelsky
                </p>
              </div>
              <span className="eyebrow bg-[#E60000] px-2.5 py-1.5">
                Director / DP
              </span>
            </div>
          </div>
        </div>

        {/* Text column */}
        <div className="lg:col-span-7 reveal">
          <p className="eyebrow text-[#E60000] mb-5">/ About</p>
          <h2 className="font-display uppercase text-4xl md:text-6xl leading-[0.95]">
            Films that
            <br />
            <span className="text-outline-red">move missions</span>
            <br />
            forward.
          </h2>

          <div className="mt-10 space-y-6 text-white/75 leading-relaxed md:text-lg max-w-2xl">
            <p>
              I'm Benny Dukelsky, founder and director of Insight Media
              Productions. I graduated from the Los Angeles Film School with a
              Bachelor's in Digital Filmmaking and have been working in video
              production since 2018.
            </p>
            <p>
              My real passion is storytelling — video just happens to be my
              favorite medium for it. Today I run Insight with a small but
              seriously capable team, partnering with nonprofits, brands and
              creators who care as much about what their story does as how it
              looks.
            </p>
            <p>
              From gala reels that fill pledge cards to courses students
              actually finish, every frame is engineered for outcome.
            </p>
          </div>

          {/* Stats */}
          <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-px bg-[#1a1a1a] border border-[#1a1a1a]">
            {STATS.map((s) => (
              <div
                key={s.label}
                className="bg-[#0a0a0a] p-6 md:p-8"
                data-testid={`stat-${s.label.toLowerCase().replace(/\s/g, "-")}`}
              >
                <p className="font-display text-3xl md:text-5xl text-white leading-none">
                  {s.value}
                </p>
                <p className="eyebrow text-white/50 mt-3">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
